import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
declare let getData: any;

@Component({
  selector: "app-media",
  templateUrl: "./media.component.html",
  styleUrls: ["./media.component.css"],
})
export class MediaComponent implements OnInit {
  constructor(public router: Router) {
    getData();
  }

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
    
  }

}
